import React from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Card from "@mui/material/Card";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import MuiLink from "@mui/material/Link";

// @mui icons
import Icon from "@mui/material/Icon";

// Material Dashboard 3 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";

function ProductCard({ product, index, updateAmountAvailable, updateProductDisplayed, updatePrice }) {
  const [visibleAmountAvailable, setVisibleAmountAvailable] = React.useState(false);
  const [visiblePrice, setVisiblePrice] = React.useState(false);
  const [amountAvailable, setAmountAvailable] = React.useState(0);
  const [price, setPrice] = React.useState("3.00");
  // const [value, setValue] = React.useState("");

  const editAmountAvailable = () => {
    if (visibleAmountAvailable) {
      updateAmountAvailable(amountAvailable, index);
      setVisibleAmountAvailable(false);
    } else {
      setAmountAvailable(product.amountAvailable);
      setVisibleAmountAvailable(true);
    }
  }

  const handleAmountAvailable = (e) => {
    setAmountAvailable(e.target.value);
  }

  const editPrice = () => {
    if (visiblePrice) {
      const formattedPrice = parseFloat(price).toFixed(2);
      updatePrice(formattedPrice, index);
      setPrice(formattedPrice);
      setVisiblePrice(false);
    } else {
      setPrice(product.price);
      setVisiblePrice(true);
    }
  }

  const handlePrice = (e) => {
    const value = e.target.value;

    // Allow only numbers and a single dot
    if (/^\d*\.?\d*$/.test(value)) {
      setPrice(value);
    }
  }

  return (
    <Card>
      <MDBox p={3}>
        <MDTypography
          display="inline"
          variant="h4"
          textTransform="capitalize"
          fontWeight="bold"
        >
          {product.title}
        </MDTypography>
        <MDBox mt={2} mb={3} display="flex" flexDirection="row" alignItems="center" gap={2}>
          <MDTypography variant="body2" component="p" color="text">
            Verfügbar:
          </MDTypography>
          <MDBox display="flex" flexDirection="row" alignItems="center" >
            {visibleAmountAvailable ? (
              <MDBox display="flex" flexDirection="row" alignItems="center">
                <MDInput
                  value={amountAvailable}
                  onChange={(e) => handleAmountAvailable(e)}
                  style={{
                    minWidth: "50px",
                    maxWidth: "50px"
                  }}
                />
                <MDBox ml={1} onClick={editAmountAvailable} style={{ cursor: "pointer" }}>
                  <Icon fontSize="small">save</Icon>
                </MDBox>
              </MDBox>
            ) : (
                <MDBox display="flex" flexDirection="row" alignItems="center">
                  <MDTypography px={2} variant="body2" component="p" color="text">
                    {product.amountAvailable}
                  </MDTypography>
                  <MDBox ml={1} onClick={editAmountAvailable} style={{ cursor: "pointer" }}>
                    <Icon fontSize="small">edit</Icon>
                  </MDBox>
                </MDBox>
            )}
          </MDBox>
        </MDBox>
        <MDBox mt={2} mb={3} display="flex" flexDirection="row" alignItems="center" gap={2}>
          <MDTypography variant="body2" component="p" color="text">
            Preis:
          </MDTypography>
          <MDBox display="flex" flexDirection="row" alignItems="center" >
            {visiblePrice ? (
              <MDBox display="flex" flexDirection="row" alignItems="center">
                <MDInput
                  value={price}
                  onChange={(e) => handlePrice(e)}
                  style={{
                    minWidth: "80px",
                    maxWidth: "80px"
                  }}
                />
                <MDBox ml={1} onClick={editPrice} style={{ cursor: "pointer" }}>
                  <Icon fontSize="small">save</Icon>
                </MDBox>
              </MDBox>
            ) : (
                <MDBox display="flex" flexDirection="row" alignItems="center">
                  <MDTypography px={2} variant="body2" component="p" color="text">
                    {product.price}
                  </MDTypography>
                  <MDBox ml={1} onClick={editPrice} style={{ cursor: "pointer" }}>
                    <Icon fontSize="small">edit</Icon>
                  </MDBox>
                </MDBox>
            )}
          </MDBox>
        </MDBox>
        <MDBox mt={2} mb={3} display="flex" flexDirection="row" alignItems="center" gap={2}>
          <MDTypography variant="body2" component="p" color="text">
            Angezeigt:
          </MDTypography>
          <AppBar position="static" style={{ width:"150px" }}>
            <Tabs
              orientation="horizontal"
              value={product.productDisplayed ? 0 : 1}
              onChange={(event, newValue) => updateProductDisplayed(event, newValue, index)}
            >
              <Tab label="Ja" />
              <Tab label="Nein" />
            </Tabs>
          </AppBar>
        </MDBox>
      </MDBox>
    </Card>
  );
}

// Typechecking props for the ProductCard
ProductCard.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  displayProduct: PropTypes.func,
};

export default ProductCard;